import type { SubmissionType } from "@/types/submission";

export const SUBMISSION_TYPE_LABELS: Record<SubmissionType, string> = {
  CONTACT: "اتصل بنا",
  QUESTIONNAIRE: "استبيان",
  FEEDBACK: "ملاحظات",
  SUBSCRIBE: "اشتراك",
};

export const SUBMISSION_TYPE_OPTIONS = (
  Object.keys(SUBMISSION_TYPE_LABELS) as SubmissionType[]
).map((value) => ({ value, label: SUBMISSION_TYPE_LABELS[value] }));

export function submissionTypeLabel(type: string): string {
  return SUBMISSION_TYPE_LABELS[type as SubmissionType] ?? type;
}
